/*
 * FIX: the theme's own cart-items/cart-drawer-items custom elements guard
 * their DOM refresh with `if (!this.lineItemContainer) return;` (see
 * updateQuantity() in shrine.null.js), but nothing in the theme ever sets
 * that property. That means every quantity change or removal DOES update
 * the cart on the server (confirmed: a full page reload shows the correct
 * state) but the visible cart/cart drawer never re-renders, so removed
 * items appear to stay, and line prices never refresh after a quantity
 * change.
 *
 * This restores the missing property without touching the core file.
 * Each cart section re-render replaces <cart-drawer-items>/<cart-items>
 * with a fresh element instance, so we re-apply on every 'cart-update'
 * pub/sub event the theme already publishes (once the guard above stops
 * blocking it).
 */
(function () {
  function patchLineItemContainers() {
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
      if (!el.lineItemContainer) {
        el.lineItemContainer = el;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchLineItemContainers);
  } else {
    patchLineItemContainers();
  }

  function trySubscribe() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(patchLineItemContainers, 0);
      });
      return true;
    }
    return false;
  }

  if (!trySubscribe()) {
    // shrine.null.js may not have finished executing yet even though it is
    // marked defer; retry briefly rather than silently giving up.
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (trySubscribe() || attempts > 20) clearInterval(retry);
    }, 100);
  }
})();

/*
 * FIX 2 (mobile): the sticky add-to-cart bar (.bifri-sticky-atc) is
 * position:fixed at the bottom of the viewport on mobile. When a customer
 * adds to cart from that bar, the cart drawer slides in and the bar stays
 * on top of it, covering the checkout button — the customer cannot reach
 * "Do kasy" without closing the drawer first.
 *
 * The drawer marks itself open with the `active` class on <cart-drawer>,
 * so hiding the bar is a pure CSS rule. The :has() selector does it with
 * no JavaScript at all; the body class below is a fallback for older
 * mobile browsers that do not support :has() yet.
 */
(function () {
  var STYLE_ID = 'selune-sticky-atc-drawer-fix';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      'body:has(cart-drawer.active) .bifri-sticky-atc,' +
      'body:has(cart-drawer.active) [data-bifri-sticky-atc],' +
      'body.selune-cart-open .bifri-sticky-atc,' +
      'body.selune-cart-open [data-bifri-sticky-atc]' +
      '{display:none !important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function syncState() {
    var drawer = document.querySelector('cart-drawer');
    var isOpen = !!(drawer && drawer.classList.contains('active'));
    document.body.classList.toggle('selune-cart-open', isOpen);
  }

  var observer = null;
  var watched = null;

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer === watched) return !!drawer;
    if (observer) observer.disconnect();
    observer = new MutationObserver(syncState);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    watched = drawer;
    syncState();
    return true;
  }

  function init() {
    injectStyle();
    if (!watchDrawer()) {
      // The drawer section can render after this script runs; retry briefly.
      var attempts = 0;
      var retry = setInterval(function () {
        attempts++;
        if (watchDrawer() || attempts > 20) clearInterval(retry);
      }, 100);
    }
    // A cart re-render can swap the <cart-drawer> element out; re-attach.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(watchDrawer, 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();